import { createFileRoute } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { renderServerComponent } from "@tanstack/react-start/rsc";
import CopyrightContent from "src/components/policies/CopyrightContent";
import CopyrightReport from "src/components/policies/CopyrightReport";
import { metadataHead } from "src/lib/Metadata";
import { withHydrationMarker } from "src/lib/ServerContent";
import { renderCachedServerComponent } from "src/server/FlightCache";

// The policy text is a server component (see CopyrightContent): rendered once per request in the RSC
// environment and streamed to the page, without its Markdown renderer in the client bundle.
const getCopyrightContent = createServerFn({ method: "GET" }).handler(() =>
  renderCachedServerComponent("policy:copyright", () =>
    renderServerComponent(withHydrationMarker(<CopyrightContent />)),
  ),
);

export const Route = createFileRoute("/_policies/copyright")({
  loader: () => getCopyrightContent(),
  // The text only changes with a deploy.
  staleTime: Number.POSITIVE_INFINITY,
  head: () =>
    metadataHead({
      title: "Copyright and DMCA",
      description: "Report copyright infringement or submit a counter-notice to CalmLens.",
      alternates: { canonical: "/copyright" },
    }),
  component: CopyrightPage,
});

function CopyrightPage() {
  return (
    <>
      {Route.useLoaderData()}
      <CopyrightReport />
    </>
  );
}
